<div class="modal-content">
    <div class="modal-header border-0">
        <h5 class="modal-title" id="modulesModalLabel">Cancelar Servicio</h5>
        <button type="button" class="btn-close" (click)="modal.dismissAll()"></button>
    </div>
    <div class="modal-body p-4">
        <form novalidate [formGroup]="cancelServiceForm">
            <div class="mb-3">
                <label class="col-12 form-label m-0" for="reason_id">Motivo <span class="txt-danger"> *</span></label>
                <select class="col-12 form-select" id="reason_id" required formControlName="reason_id"
                        [ngClass]="{ 'is-invalid' : (reasonId?.touched || validate) && reasonId?.errors, 'is-valid' : !reasonId?.errors}">
                    <option [ngValue]="" disabled selected>Motivo de cancelación</option>
                    <option *ngFor="let reason of reasonList" [value]="reason.id">{{ reason.value }}</option>
                </select>
                @if (reasonId?.errors) {
                    <div class="invalid-feedback">Selecciona un mótivo de la cancelación</div>
                }
            </div>
            <div class="mb-3">
                <label class="col-12 form-label m-0" for="cancellation_cost">Costos de cancelación<span class="txt-danger"> *</span></label>
                <div class="col-12 input-group"><span class="input-group-text">$</span>
                    <input class="form-control" type="text" id="cancellation_cost" formControlName="cancellation_cost" [class.is-invalid]="cancelServiceForm.get('cancellation_cost')?.touched && cancelServiceForm.get('cancellation_cost')?.invalid">
                    <span class="input-group-text">MXN</span>
                </div>
                <div *ngIf="cancelServiceForm.get('cancellation_cost')?.touched && cancelServiceForm.get('cancellation_cost')?.invalid" class="invalid-feedback">
                    Ingrese un costo válido.
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer border-0 pt-3">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismissAll()">Cerrar</button>
        <button type="button" class="btn btn-primary" (click)="cancelService()">Cancelar Servicio</button>
    </div>
</div>
